import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { ProductArtwork } from './ProductArtwork';
import { PRODUCT_NAME } from './constants';
export function FinalCTA() {
  return <section className="border-t-8 border-sport bg-navy px-4 py-7 text-white sm:py-9" data-id="element-48" data-mp="c8byj14ww7bg">
      <div className="mx-auto max-w-3xl text-center" data-id="element-49" data-mp="84dz0pbocuhv">
        <p className="text-xs font-display font-bold uppercase tracking-widest text-sport" data-id="element-50" data-mp="m4ovq8zo13ay">
          ONE LAST CHANCE
        </p>
        <div className="mx-auto mt-2 max-w-2xl space-y-2 text-sm leading-relaxed text-white/90 sm:text-base" data-id="element-51" data-mp="h4u586jsyfqf">
          <p data-id="element-52" data-mp="vtgjs61lv3gl">
            Your athletes deserve more than training sessions created at the
            last minute because you simply ran out of planning time.
          </p>
          <p data-id="element-53" data-mp="14uofqhgnfs7i">
            Stop spending hours building strength programs, creating workouts,
            organizing periodization, and planning every training session from
            scratch.
          </p>
          <p data-id="element-54" data-mp="2c5pxlx9spg38">
            Stop wasting valuable time jumping between books, certifications,
            spreadsheets, websites, videos, and scattered coaching files.
          </p>
          <p data-id="element-55" data-mp="2m2b3slxjwx8n">
            Deliver every session with structure, confidence, and a professional
            coaching system built to help your athletes become stronger, faster,
            and perform at their highest level.
          </p>
          <p data-id="element-56" data-mp="2v2zi7hquwzm2">
            Give yourself the complete Strength &amp; Conditioning coaching
            system you wish you had from your very first training session.
          </p>
        </div>

        <ProductArtwork className="mx-auto my-4 max-w-[220px] drop-shadow-2xl" data-id="element-57" data-mp="34un1uwh69ccz" />

        <div className="rounded-xl border border-white/25 bg-white/10 p-3" data-id="element-58" data-mp="39somvmy5rlr3">
          <p className="text-sm font-display font-bold uppercase" data-id="element-59" data-mp="3errthbtse016">
            💪 {PRODUCT_NAME} — Complete 6-in-1 Planning System + 5 Premium
            Bonuses
          </p>
          <p className="mt-1 text-sm" data-id="element-60" data-mp="3iqqtci0nv6lr">
            <span className="line-through text-white/65" data-id="element-61" data-mp="1jnk1e5sjjqs4">
              Regular Price: $97
            </span>{' '}
            <span className="text-sport" data-id="element-62" data-mp="1eqjtdpc4sdyd">| Today Only: $27 USD</span>
          </p>
        </div>

        <div className="mx-auto mt-4 max-w-md" data-id="element-63" data-mp="1shouywz27gbc">
          <CTAButton className="!bg-sport !shadow-sport/30 hover:!bg-[#e37835]" data-id="element-64" data-mp="1sihylp2q1pp9">
            🚀 YES! I WANT MY STRENGTH READY™ SYSTEM
          </CTAButton>
        </div>

        <div className="mt-4 flex flex-wrap justify-center gap-x-4 gap-y-1.5 text-xs font-bold text-white/90" data-id="element-65" data-mp="22d9w6swb0ck1">
          <span className="inline-flex items-center gap-1" data-id="element-66" data-mp="1xhuhxzudwen3">
            <ZapIcon className="h-4 w-4 text-sport" data-id="element-67" data-mp="2behpsxnvkp7s" />
            Immediate Access • Delivered Instantly by Email
          </span>
          <span className="inline-flex items-center gap-1" data-id="element-68" data-mp="27epdc9vd1yx5">
            <StarIcon className="h-4 w-4 fill-sport text-sport" data-id="element-69" data-mp="h0qapims1d4y" />
            4.9/5 — Verified Coach Reviews
          </span>
          <span className="inline-flex items-center gap-1" data-id="element-70" data-mp="d1hem749l368">
            <ShieldCheckIcon className="h-4 w-4 text-sport" data-id="element-71" data-mp="2vg7bwzroj8s" />
            7-Day Money-Back Guarantee — Zero Risk
          </span>
        </div>
      </div>
    </section>;
}